// extracted by mini-css-extract-plugin
export var aboveInput = "_n6-0";
export var actionButton = "_n6-5";
export var actionButtonContainer = "_n6-1";
export var actionIcon = "_n6-6";
export var aiInfoContainer = "_n6-2";
export var attachmentWrapper = "_n6-7";
export var bold = "_n6-3";
export var checkIcon = "_n6-8";
export var clickingRecipientBar = "_n6-11";
export var commentThreadSwitch = "_n6-a";
export var draftImage = "_n6-b";
export var draftImageContainer = "_n6-c";
export var draftImages = "_n6-e";
export var editButton = "_n6-g";
export var editor = "_n6-f";
export var editorContainer = "_n6-y";
export var editorErrorTooltipWrapper = "_n6-9";
export var headerDivider = "_n6-h";
export var icon = "_n6-i";
export var info = "_n6-j";
export var internal = "_n6-n";
export var internalDivider = "_n6-k";
export var internalMessage = "_n6-l";
export var messageInputCard = "_n6-m";
export var messageInputForm = "_n6-o";
export var messageInputFormInternal = "_n6-p";
export var options = "_n6-q";
export var publicMessageCustomer = "_n6-s";
export var publicMessageMerchant = "_n6-r";
export var removeImageButton = "_n6-d";
export var replyButtons = "_n6-t";
export var showSignatureButton = "_n6-u";
export var spinner = "_n6-v";
export var verticalButtonDivider = "_n6-4";
export var visibilitySelector = "_n6-w";
export var warning = "_n6-x";
export var wrappingText = "_n6-z";
export var writingInternalNoteTopBorder = "_n6-10";